var exports = {
  "Kk": "xfd349460--381a37--icon",
  "S$": "xfd349460--381a37--agency",
  "Qq": "xfd349460--381a37--text",
  "DD": "xfd349460--381a37--title",
  "VA": "xfd349460--381a37--subtitle",
};

module.exports = exports;
